module.exports = __webpack_public_path__ + "img/bannerImage.1f1aac44.png";